import { createSelector } from '@reduxjs/toolkit';
import pickBy from 'lodash/pickBy';

const baseSelector = (state) => state.scheduleClassesForm;

export const librarySelector = (state) => baseSelector(state).library;

export const superBatchesSelector = (state) => baseSelector(state).superBatches;

export const scheduleClassesFormAcademyScheduleSelector = (state) =>
  baseSelector(state).academySchedule;

export const scheduleClassesFormStartDateSelector = (state) =>
  baseSelector(state).startDate;

export const academyTopicsSelector = (state) =>
  baseSelector(state).academyTopics;

export const instructorRequiredAcademyTopicsSelector = createSelector(
  academyTopicsSelector,
  (academyTopics) => {
    return pickBy(
      academyTopics,
      (academyTopic) => academyTopic.isInstructorRequired
    );
  }
);

export const selectedInstructorRequiredAcademyTopicsSelector = createSelector(
  instructorRequiredAcademyTopicsSelector,
  (academyTopics) => {
    return Object.values(academyTopics).filter((o) => o.selected);
  }
);

export const selectedAcademyTopicsSelector = createSelector(
  academyTopicsSelector,
  (academyTopics) => {
    return Object.values(academyTopics).filter((o) => o.selected);
  }
);

export const areAllInstructorsSameSelector = createSelector(
  selectedInstructorRequiredAcademyTopicsSelector,
  (_, instructorType) => instructorType,
  (academyTopics, instructorType) => {
    if (academyTopics.length === 0) return false;

    const areAllInstructorsSelected = academyTopics.every((o) =>
      Boolean(o[instructorType])
    );
    const selectedInstructorIds = new Set(
      academyTopics.map((academyTopic) => academyTopic[instructorType]?.value)
    );

    return areAllInstructorsSelected && selectedInstructorIds.size === 1;
  }
);

export const areAllClassesSelectedSelector = createSelector(
  academyTopicsSelector,
  (academyTopics) => {
    const list = Object.values(academyTopics);
    return list.length > 0 && list.every((o) => o.selected);
  }
);

export const academyTopicSelector = createSelector(
  academyTopicsSelector,
  (_, academyTopicId) => academyTopicId,
  (academyTopics, academyTopicId) => academyTopics[academyTopicId]
);

export const scheduleErrorsSelector = (state) => baseSelector(state).errors;

export const confirmationModalSelector = (state) =>
  baseSelector(state).isConfirmationOpen;

export const trackerModalSelector = createSelector(
  (state) => baseSelector(state),
  ({ classCreationTrackerId, isTrackerOpen }) => ({
    isOpen: isTrackerOpen,
    trackerId: classCreationTrackerId,
  })
);
